import script from "./DaysPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./DaysPicker.vue?vue&type=script&lang=ts&setup=true"

import "./DaysPicker.vue?vue&type=style&index=0&id=33547d4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33547d4a"]])

export default __exports__